import { render, staticRenderFns } from "./final-confirmation.vue?vue&type=template&id=2cf9dae9&lang=pug&"
import script from "./final-confirmation.vue?vue&type=script&lang=js&"
export * from "./final-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports